/**
 * Detects if HTML content originates from Microsoft Word
 */
export class WordDetector {
  static INDICATORS = [
    /<!--\[if gte mso/i, // Word conditional comments
    /mso-/i, // Word-specific CSS properties
    /<o:p>/i, // Word paragraph tags
    /<w:/i, // Word XML namespace
    /class="?Mso/i, // Word CSS classes
    /style="[^"]*mso-/i, // Inline Word styles
    /<span[^>]*lang="?[A-Z]{2}-[A-Z]{2}"?/i, // Language attributes
    /font-family:[^;]*"Times New Roman"/i, // Default Word font
  ];

  static isWordContent(html) {
    if (!html || typeof html !== 'string') {
      return false;
    }

    const matchedIndicators = [];
    const result = this.INDICATORS.some((indicator) => {
      const matches = indicator.test(html);
      if (matches) {
        matchedIndicators.push(indicator.toString());
      }
      return matches;
    });

    return result;
  }
}
